import 'url-search-params-polyfill';
import axios from 'axios';

import { getGendersForLeagueSearch } from '../utils/types';

let searchCancelToken;

export const getDashboardTeams = (axiosInstance) => {
    const url = `v2/leagues/my-teams`;
    return axiosInstance.get(url);
};

export const getLeagueSessions = (axiosInstance, leagueId, sportTypeId, filters, page) => {
    const params = new URLSearchParams();

    if (searchCancelToken) {
        searchCancelToken();
    }

    const { CancelToken } = axios;

    const genderFilters = getGendersForLeagueSearch(filters?.gender);

    genderFilters.forEach(gender => {
        params.append('GenderTypeId', gender);
    });

    params.append('MinDateTimeUtc', filters.startDate ? filters.startDate.format('YYYY-MM-DD') : '2020-01-01');
    params.append('MaxDateTimeUtc', filters.endDate ? filters.endDate.format('YYYY-MM-DD') : '2099-12-31');
    params.append('AgeMin', filters.ageMin);
    params.append('AgeMax', filters.ageMax);
    params.append('ConferenceRatings.RatingMin', filters.ratingMin);
    params.append('ConferenceRatings.RatingMax', filters.ratingMax);
    params.append('PageNumber', page || 1);
    params.append('PageSize', 5);
    params.append('SportTypeId', sportTypeId);

    if (filters.LeagueSessionType !== 0) {
        params.append('SessionTypeId', filters.LeagueSessionType);
    }

    return axiosInstance.get(`/v2/leagues/${leagueId}/sessions`, {
        params,
        cancelToken: new CancelToken((c) => {
            searchCancelToken = c;
        }),
    });
};

export const getLeagueTeams = (axiosInstance, activeOnly) => {
    const url = activeOnly ? `v2/leagues/member/teams?activeOnly=${activeOnly}` : `v2/leagues/member/teams`;
    return axiosInstance.get(url);
};

export const getOrganizerTeamLeagues = (axiosInstance, clubId) => {
    const url = `v1/leagues/my-leagues?clubId=${clubId}`;
    return axiosInstance.get(url);
};
